// extracted by mini-css-extract-plugin
module.exports = {"Youtube":"VideoYoutube_Youtube__T5ojK","fadein":"VideoYoutube_fadein__3ogDi"};